import { Flex, Icon } from "orcs-design-system";
import React from "react";

import icons from "src/config/icons";

const DropdownIndicator = () => {
  return (
    <Flex alignItems="center" px="s">
      <Icon icon={icons.search} color="subText" />
    </Flex>
  );
};

export default DropdownIndicator;
